const BASE = process.env.REACT_APP_API_URL || '/api';

export function authHeaders(json = true) {
  const headers = {};
  if (json) headers['Content-Type'] = 'application/json';
  const token = localStorage.getItem('md_token');
  if (token) headers['Authorization'] = token;
  return headers;
}

export async function post(endpoint, data) {
  const res = await fetch(`${BASE}/${endpoint}.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

/** GET community / public endpoints (?action=list&...) */
export async function get(endpoint, params = {}) {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
  ).toString();
  const url = `${BASE}/${endpoint}.php${qs ? `?${qs}` : ''}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

/** POST with Authorization header (community endpoints use ?action=...) */
export async function postAuth(endpoint, queryParams = {}, body = {}) {
  const qs = new URLSearchParams(queryParams).toString();
  const url = `${BASE}/${endpoint}.php${qs ? `?${qs}` : ''}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

/** Multipart image upload — returns { ok, url } */
export async function uploadFile(file) {
  const fd = new FormData();
  fd.append('file', file);
  const token = localStorage.getItem('md_token');
  const res = await fetch(`${BASE}/upload.php`, {
    method: 'POST',
    headers: token ? { Authorization: token } : {},
    body: fd,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}
